export default __webpack_public_path__ + "static/media/scroll-down-arrow.a016b8a1.svg";